import { Injectable } from '@angular/core';
import {CryptService} from './crypt.service';
import {ConstsHelper} from '../../../helpers/consts.helper';
import {SupportUserInterface} from '../models/support-user.interface';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class ExtranetService {

  constructor(private cryptService: CryptService, private cookieService: CookieService) {}

  /**
   * Get support user
   */
  getSupportUser(): SupportUserInterface|null {
    if (this.cookieService.get(ConstsHelper.COOKIE_EXTRANET_TOKEN)) {
      return JSON.parse(this.cryptService.decrypt(this.cookieService.get(ConstsHelper.COOKIE_EXTRANET_TOKEN)));
    }
    return null;
  }
}
